import { Group, Text } from "@mantine/core";

const TravellerDrawerRow = ({ label, value, highlight }) => (
  <Group justify="space-between" wrap="nowrap" py={6}>
    <Text size="xs" c="dimmed" tt="uppercase" fw={600}>
      {label}
    </Text>
    <Text size="sm" fw={600} ta="right" c={highlight || undefined}>
      {value ?? "—"}
    </Text>
  </Group>
);

export default TravellerDrawerRow;
